import { Box, BoxProps, Stack, StackProps } from '@mui/material';
import React, { ReactNode } from 'react';

import { EventPages } from './constants';
import { EventPageHeader } from './EventPageHeader';

export interface EventPageProps extends Pick<StackProps, 'children'> {
  currentPage: EventPages;
  renderHeaderActions?: () => ReactNode;
  isTableView?: boolean;
}

export const EventPage = ({
  children,
  currentPage,
  renderHeaderActions,
  isTableView = true,
}: EventPageProps) => {
  const boxProps: BoxProps = isTableView
    ? { display: 'flex', flexDirection: 'row', flexGrow: 1, overflow: 'auto' }
    : {};

  return (
    <Stack p={3} height='100%'>
      <EventPageHeader
        currentPage={currentPage}
        renderHeaderActions={renderHeaderActions}
      />
      <Box {...boxProps}>{children}</Box>
    </Stack>
  );
};
